/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductCostService = {
  /**
   * Get Screen data
   *
   * */
  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/ProductCost",
      expand: "Product($select=Code,Description1,StockItem,AvailableForSale,IsKit,Source), Branch($select=Description)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getByCodeAndBranch (productCode,branchCode) {
    const requestScreenData = {
      url: "api/ProductCost",
      top: "1",
      filter: `ProductCode eq '${productCode}' and BranchCode eq '${branchCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async save(mode, productCost) {
    var payload = productCost;
    var url = "api/ProductCost";

    return await ApiService.patch(url, productCost.RecordId, payload, "Guid");
    
  },
  async delete(productCost) {
    var url = "api/ProductCost";

    return await ApiService.delete(url, productCost.RecordId, "Guid");
  },
};

export { ProductCostService };
